import React, { useState } from 'react';
import { translate } from '../../../Services/translation';

const TermsModalComponent = ({ modalTermsText, onButtonChoice }) => {
  const [firstOptionChoice, setFirstOptionChoice] = useState(null);
  const [secondOptionChoice, setSecondOptionChoice] = useState(null);
  const handleButtonChoice = (choice, option) => {
    onButtonChoice(choice, option);
    if (option === 'first') {
      setFirstOptionChoice(choice);
    } else if (option === 'second') {
      setSecondOptionChoice(choice);
    }
  };

  return (
    <div className="terms-modal-container">
      <p className="terms-modal-container--title">
        {translate('investment-page-modal-terms-title')}
      </p>
      <div
        className="terms-modal-container--text"
        dangerouslySetInnerHTML={{ __html: modalTermsText }}
      />
      <div className="terms-modal-container--button-container">
        <div className="terms-modal-container--button-container__inner">
          <div className="terms-modal-container--button-container__inner--text">
            {translate('investment-page-term-first-option')}
          </div>
          <div className="terms-modal-buttons-container">
            <button
              onClick={() => handleButtonChoice('yes', 'first')}
              className={firstOptionChoice === 'yes' ? 'selected' : ''}
            >
              {translate('investment-page-term-button-text-yes')}
            </button>
            <button
              onClick={() => handleButtonChoice('no', 'first')}
              className={firstOptionChoice === 'no' ? 'selected' : ''}
            >
              {translate('investment-page-term-button-text-no')}
            </button>
          </div>
        </div>
        <div className="terms-modal-container--button-container__inner">
          <div className="terms-modal-container--button-container__inner--text">
            {translate('investment-page-term-second-option')}
          </div>
          <div className="terms-modal-buttons-container">
            <button
              onClick={() => handleButtonChoice('yes', 'second')}
              className={secondOptionChoice === 'yes' ? 'selected' : ''}
            >
              {translate('investment-page-term-button-text-yes')}
            </button>
            <button
              onClick={() => handleButtonChoice('no', 'second')}
              className={secondOptionChoice === 'no' ? 'selected' : ''}
            >
              {translate('investment-page-term-button-text-no')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModalComponent;
